import type { ReactNode } from 'react'
import Brand from '@/components/Brand'
import FlashBanner from '@/components/FlashBanner'

// Layout for a page that is a document read signed out (the privacy policy
// the Connect ESPN extension's store listing points at): the brand, then one
// reading column, no navigation. Picked by page name in entrypoints/inertia.tsx.
export default function DocumentLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh px-safe pt-safe">
      <header className="border-b border-line bg-surface">
        <div className="mx-auto max-w-2xl px-4 sm:px-6">
          <div className="flex min-h-15 items-center">
            <Brand />
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-2xl px-4 py-8 sm:px-6">
        <FlashBanner />
        {children}
      </main>
    </div>
  )
}
